import {List, Map as ImmutableMap, OrderedMap, Set as ImmutableSet, OrderedSet, Stack, Seq} from 'immutable';

export default function copyGenerator (obj, generatorFn) {
  let iterable = generatorFn(
      this.yieldableFor(obj), this.entries(obj));
  if (obj instanceof List) {
    return new List(iterable);
  } else if (obj instanceof ImmutableMap) {
    return new ImmutableMap(iterable);
  } else if (obj instanceof OrderedMap) {
    return new OrderedMap(iterable);
  } else if (obj instanceof ImmutableSet) {
    return new ImmutableSet(iterable);
  } else if (obj instanceof OrderedSet) {
    return new OrderedSet(iterable);
  } else if (obj instanceof Stack) {
    return new Stack(iterable);
  } else if (obj instanceof Seq.Keyed) {
    return new (Seq.Keyed)(iterable);
  } else if (obj instanceof Seq.Indexed) {
    return new (Seq.Indexed)(iterable);
  } else if (obj instanceof Seq.Set) {
    return new (Seq.Set)(iterable);
  } else {
    return this.NotApplicable;
  }
}



// WEBPACK FOOTER //
// ./lib/rlink-collections/immutable/copyGenerator.js